/**
 * Computes the new pinned list after toggling a domain.
 * Returns null if no change (at capacity and not already pinned).
 */
export function togglePinInList(current: number[], domainId: number, maxPinned: number): number[] | null {
    const index = current.indexOf(domainId)

    if (index !== -1) {
        return current.filter((id) => id !== domainId)
    }

    if (current.length >= maxPinned) {
        return null
    }

    return [...current, domainId]
}
